import { AkamLogoCheckIcon, AkamLogoTextIcon, InstagramIcon, TelegramIcon } from 'icons';
import Link from 'next/link';
import { useRouter } from 'next/router';

import { globalConst } from 'modules/global';

const MainFooter = () => {
  const { locale = 'uz' } = useRouter();
  const t = globalConst.extraTranslation.footer[locale as 'uz' | 'ru'];

  return (
    <div className="bg-gray-800 py-12 text-gray-300">
      <div className="container mx-auto max-w-[1254px] px-4">
        <div className="grid gap-8 md:grid-cols-4">
          {/* Logo and Description */}
          <div className="md:col-span-2">
            <Link href="/" aria-label='Akam logo' className="mb-4 flex items-center gap-2">
              <AkamLogoCheckIcon />
              <AkamLogoTextIcon />
            </Link>
            <p className="text-md mt-4 max-w-xs font-bold leading-relaxed ">{t?.footer_title}</p>
          </div>

          {/* Contact Us */}
          <div className="mr-5">
            <h2 className="mb-4 text-lg font-medium text-white">{t?.contact_us}</h2>
            <div className="space-y-3 text-sm">
              <div>
                <span className="text-gray-400">{t?.contact}: </span>
                {/* eslint-disable-next-line i18next/no-literal-string */}
                <Link href="tel:+998933868775" target="_blank">
                  +998 93 386 87 75
                </Link>
              </div>
              <div>
                <span className="text-gray-400">{t?.address}:</span>
                {/* eslint-disable-next-line i18next/no-literal-string */}
                <span> Toshkent, ko'cha. Аxmad Donish, 20А 100180</span>
              </div>
            </div>
          </div>

          {/* Social */}
          <div>
            <h3 className="mb-4 text-lg font-medium text-white">{t?.social}</h3>
            <div className="space-y-3 text-sm">
              <div className="flex items-center gap-2">
                <Link
                  href="https://www.instagram.com/akam.uz/"
                  target="_blank"
                  className="text-gray-300 transition-colors hover:text-white"
                >
                  <span className="flex items-center gap-1 text-gray-400 hover:text-white">
                    {' '}
                    {/* eslint-disable-next-line i18next/no-literal-string */}
                    <InstagramIcon />
                    Instagram
                  </span>
                </Link>
              </div>
              <div className="flex items-center gap-2">
                <Link
                  href="https://t.me/akamuz"
                  target="_blank"
                  className="text-gray-300 transition-colors hover:text-white"
                >
                  <span className="flex items-center gap-1 text-gray-400 hover:text-white">
                    {' '}
                    {/* eslint-disable-next-line i18next/no-literal-string */}
                    <TelegramIcon width="18" height="15" />
                    Telegram
                  </span>
                </Link>
              </div>
            </div>
            {/* <div className="mt-6 flex gap-4">
              <Link
                href="https://www.instagram.com/akam.uz/"
                target="_blank"
                className="text-gray-300 transition-colors hover:text-white"
              >
                <InstagramIcon />
              </Link>
              <Link
                href="https://t.me/akamuz"
                target="_blank"
                className="text-gray-300 transition-colors hover:text-white"
              >
                <TelegramIcon width="24" height="18" />
              </Link>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainFooter;
